var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeeAllArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94675 6.00001L0.8735 1.92701C0.735167 1.78851 0.664333 1.61443 0.661 1.40476C0.657833 1.19526 0.728667 1.01801 0.8735 0.873012C1.0185 0.728178 1.19417 0.655762 1.4005 0.655762C1.60683 0.655762 1.7825 0.728178 1.9275 0.873012L6.42175 5.36726C6.51525 5.46093 6.58125 5.55968 6.61975 5.66351C6.65825 5.76735 6.6775 5.87951 6.6775 6.00001C6.6775 6.12051 6.65825 6.23268 6.61975 6.33651C6.58125 6.44035 6.51525 6.5391 6.42175 6.63276L1.9275 11.127C1.789 11.2653 1.61492 11.3362 1.40525 11.3395C1.19575 11.3427 1.0185 11.2718 0.8735 11.127C0.728667 10.982 0.65625 10.8063 0.65625 10.6C0.65625 10.3937 0.728667 10.218 0.8735 10.073L4.94675 6.00001Z",
    fill: "#FF900A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeAllArrow);
export default __webpack_public_path__ + "static/media/seeAllArrow.e15f972631d68fd68e0524c0c545673e.svg";
export { ForwardRef as ReactComponent };